"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconGlassBreakageFilled = function IconGlassBreakageFilled(_ref) {
  var className = _ref.className,
      color = _ref.color,
      size = _ref.size;
  return /*#__PURE__*/_react.default.createElement("svg", {
    id: "icons",
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 50 50"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M26,32.37V40.5a.5.5,0,0,0,.5.5h3A2.5,2.5,0,0,1,32,43.5h0a.5.5,0,0,1-.5.5h-13a.5.5,0,0,1-.5-.5h0A2.5,2.5,0,0,1,20.5,41h3a.5.5,0,0,0,.5-.5V32.37a.5.5,0,0,0-.43-.49A9,9,0,0,1,16,23V9.5a.5.5,0,0,1,.5-.5h5.19a.51.51,0,0,1,.45.28l1.75,3.5a.49.49,0,0,1,0,.44l-1.77,3.54a.49.49,0,0,0,0,.47l2.57,4.5a.5.5,0,0,0,.93-.32l-.6-4.2a.51.51,0,0,1,.09-.38l2.78-3.7a.51.51,0,0,0,.1-.3V9.5a.5.5,0,0,1,.5-.5h5a.5.5,0,0,1,.5.5V23a9,9,0,0,1-7.57,8.88A.5.5,0,0,0,26,32.37Z",
    fill: color
  }));
};

IconGlassBreakageFilled.defaultProps = {
  color: 'black',
  size: 30
};
IconGlassBreakageFilled.propTypes = {
  color: _propTypes.string,
  className: _propTypes.string
};
var _default = IconGlassBreakageFilled;
exports.default = _default;